import { useGetAllProvincesQuery } from '@exam-center/graphql';
import { useMemo } from 'react';

import { BaseSearchSelection } from '../../components';

interface ProvinceSearchSelectionProps {
  value: string[];
  onChange: (value: string[]) => void;
}

export default function ProvinceSearchSelection(props: Readonly<ProvinceSearchSelectionProps>) {
  const { value, onChange } = props;
  const { data } = useGetAllProvincesQuery();

  const provinceOptions = useMemo(() => {
    return (
      data?.ecGetAllProvinces?.provinces.map((province) => ({
        label: province.nameTh,
        value: province.id,
      })) ?? []
    );
  }, [data]);

  return (
    <BaseSearchSelection
      options={provinceOptions}
      label='จังหวัด'
      value={value}
      onChange={onChange}
    />
  );
}
